/* ===================================
 * http请求封装
 * =================================== */
import axios from 'axios';
import { Toast } from 'vant';
import router from '../router';
import { isEmpty, isEmptyObject } from '../utils/util';
import { getTemToken, getTimeStamp, getUrlParams } from '../utils';
// import { Login } from '@/api/api_home'

const channel = 3
const temToken = getTemToken()

/**
 * 格式化url
 */
function formatUrl (url) {
	let baseUrl = '';
	url = url.replace(/\/\//g, '/');
	if (process.env.VUE_APP_BASEURL) {
		baseUrl = process.env.VUE_APP_BASEURL;
		if (baseUrl.endsWith('/')) { // 判断是否作为结尾
			baseUrl = baseUrl.substring(0, baseUrl.length - 1);
		}
	}
	if (url && !url.startsWith('/')) { // 判断当前字符串是否以 "/" 作为开头
		baseUrl += '/';
	}
	baseUrl += url;
	return baseUrl;
}

/**
 * 获取头信息
 */
const getHeaders = (options = {}) => {
	// header头参数设置
	const defaultHeaders = {
		'token': localStorage.getItem('token') || temToken || '',
		'userId': localStorage.getItem('userId') || '',
		's': localStorage.getItem('s')  || 'H5',
		'sign': getTimeStamp()
	};
	if (options && options.headers && typeof options.headers === 'object') {
		const headers = options.headers;
		for (const key in headers) {
			if (key && Object.prototype.hasOwnProperty.call(headers, key)) {
				defaultHeaders[key] = headers[key];
			}
		}
	}
	return defaultHeaders;
};

const openLoading = ()=>{
	Toast.loading({
		duration: 0,
		message: '加载中...',
		forbidClick: true
	})
}

/**
 * 请求
 * @param method
 * @param url
 * @param params
 * @param options
 * @returns {Promise<any>}
 */
const request = (method, url, params, options = {}) => {
	return new Promise((resolve, reject) => {
		params = params || {};
		url = (/^https?/.test(url) || options.localUrl) ? url : formatUrl(url);
		options.headers = getHeaders(options);
		options = Object.assign({
			method: 'get',          // 请求方法类型
			url: '',                // 请求地址
			timeout: 40000,         // 请求超时时间（毫秒）40s
			headers: {},            // 头信息
			localUrl: false,        // 是否本地url，false: 根据配置文件 url会被重写, true: url保持原样不变
			params: null,           // 参数(get类型)
			data: null,             // 参数(body类型)
			interceptRes: true,    // 是否开启统一错误处理
			isEncrypt: false,  	    // 是否加密传输数据
			cache: false,           // 是否开启缓存
			reportProgress: false,  // 是否开启进度条
			fileName: '',  		    // 文件名
			loading: true,		    // 是否开启loading状态
			withCredentials: false,	// 是否携带cookie信息
			responseType: 'json'	// 响应格式: 可选项 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
		}, options, { method, url });
		if (method === 'delete' || method === 'get') {
			if (!isEmptyObject(params)) {
				options.params = params
				options.params.channel = channel
				options.params.userId = localStorage.getItem('userId') || ''
				options.params.token  =  localStorage.getItem('token')  || temToken || ''
			}
		} else {
			options.data = params
			options.data.channel = channel
			options.data.userId = localStorage.getItem('userId') || ''
			options.data.token  =  localStorage.getItem('token') || temToken || ''
		}
		if (options.loading) openLoading();
		axios.request(options).then(response => {
			if (options.loading) Toast.clear();
			// 是否对返回结果统一处理
			if (options.interceptRes) {
				if (interceptResponse(response.data)) {
					return resolve(response.data);
				}
			} else {
				return resolve(response.data);
			}
		}).catch(err => {
			if (options.loading) Toast.clear();
			if (String(err).includes('timeout')) {
				Toast('请求超时，请重新刷新');
			}
			if (err.response.status >= 500) {
				router.push({path: '/error'})
			}
			reject(err);
		});
	});
}

/**
 * 返回错误信息
 * @type {{}}
 */
// const erroMessage = {
// 	400: '用户发出的请求有错误，服务器没有进行新建或修改数据的操作',
// 	401: '表示用户没有权限',
// 	403: '表示用户得到授权（与401错误相对），但是访问是被禁止的',
// 	404: '用户发出的请求针对的是不存在的记录',
// 	406: '用户请求的格式不可得',
// 	410: '用户请求的资源被永久删除',
// 	422: '当创建一个对象时，发生一个验证错误',
// 	500: '服务器发生错误'
// }

/**
 * 响应拦截
 * @param result
 * @returns {*}
 */
const interceptResponse = (result) => {
	if (!result || !result.ok) {
		handleResponse(result);
		return null;
	}
	return result;
};

/**
 * 处理请求结果：包提提示信息、登录验证等
 * @param result
 */
export const handleResponse = (result) => {
	// TODO
	//  错误信息的判断
	//  内部错误提示
	let msg = ''
	if (!result) {
		msg = '网络繁忙,未返回数据';
		Toast(msg);
	} else if (!result.ok && isEmpty(result.code)) {
		msg = result.msg;
		Toast(msg);
	}
	// 处理各种code码错误情况和登录过期等问题
	if(result && !isEmpty(result.code)) {
		if (result.code == '000002' || result.code == '000003') {
			if(localStorage.getItem('s') === 'BS') {
				if(window.location.href.indexOf("/home") > -1){
					router.replace('/home')
				}else {
					router.push('/home')
				}
			} else {
        // token失效
        let _s = getUrlParams('s') || ''
        let _loginChannel = getUrlParams('loginChannel') || ''
        _s ? localStorage.setItem('s') : localStorage.removeItem('s')
        _loginChannel ? localStorage.setItem('loginChannel') : localStorage.removeItem('loginChannel')
				router.push('/login')
			}
		} else if(result.code == '200002'){
			router.replace({
				path:'/forbidpage'
			})
		} else if(result.code == '000500'){
			router.replace({
				path:'/error'
			})
		} else {
			Toast(result.msg);
		}
	}
};


/**
 * get方法
 * @param url 接口地址
 * @param params 参数 [可选]
 * @param options 参数 [可选]
 * @returns {Promise}
 */
export const get = (url, params, options) => request('get', url, params, options);

/**
 * post请求
 * @param url 接口地址
 * @param params 参数 [可选]
 * @param options 参数 [可选]
 * @returns {Promise}
 */
export const post = (url, params, options) => request('post', url, params, options);

/**
 * patch请求
 * @param url 接口地址
 * @param params 参数 [可选]
 * @param options 参数 [可选]
 * @returns {Promise}
 */
export const patch = (url, params, options) => request('patch', url, params, options);

/**
 * put请求
 * @param url 接口地址
 * @param params 参数 [可选]
 * @param options 参数 [可选]
 * @returns {Promise}
 */
export const put = (url, params, options) => request('put', url, params, options);

/**
 * delete请求
 * @param url 接口地址
 * @param params 参数 [可选]
 * @param options 参数 [可选]
 * @returns {Promise}
 */
export const del = (url, params, options) => request('delete', url, params, options);
